/**
 * Footer Component
 * ================
 * Application footer with copyright and About link.
 * Visible on both web and desktop client.
 */

import { Link } from 'react-router-dom'
import { Info } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()
  const appVersion = '1.33.3'

  return (
    <footer className="border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 py-3 px-4">
      <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
        <div>
          © {currentYear} Ásgeir Helgi Ásgeirsson Holm
        </div>
        <div className="flex items-center gap-4">
          <span className="text-gray-400 dark:text-gray-500">v{appVersion}</span>
          <Link
            to="/about"
            className="flex items-center gap-1 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
          >
            <Info size={12} />
            About
          </Link>
        </div>
      </div>
    </footer>
  )
}
